import _, { cloneDeep } from "lodash";
import { uuidv4 } from "@/utils/helpers";
import { isMenu } from "@/utils/products";

const uuid = require("uuid");

const MAX_DLD_COUNT = 1;
const TYPE_WASH = "wash";
const UUID_PREFIX_DLD = "DLD";
const META_DATA_ATTR_DLD_UUID = "dld_uuid";

export function getDldData(basket) {
  let result = [];
  basket.forEach(bi => {
    if (!isMenu(bi) && bi.meta_data[META_DATA_ATTR_DLD_UUID]) {
      result.push({
        name: bi.name,
        dld_uuids: bi.meta_data[META_DATA_ATTR_DLD_UUID]
      });
    }
  });
  return result;
}

/**
 * Returns true if basket contains at least one product with meta_data attr 'type'='wash' false otherwise
 * @param basket current basket
 * @returns boolean
 */
export function containsDelayedDeliveryProduct(basket) {
  return basket.some(bi => bi.meta_data && bi.meta_data.type === TYPE_WASH);
}

/**
 * Iterates basket and adds meta_data attr 'dld_uuid' for basket items of type 'wash'
 * @param basket current basket
 * @returns newBasket with generated dld data for basket items of type 'wash'
 */
export function handleExtendasDelayedDelivery(basket) {
  return basket.map(bi => {
    if (bi.meta_data && bi.meta_data.type === TYPE_WASH) {
      return addDldUuidToCarwashBasketItemMetaData(bi);
    } else {
      return bi;
    }
  });
}

/**
 * Validates dld uuid. Prefix must be DLD. uuid part must be uuid version 4.
 * @param dldUuid dld uuid string
 * @returns {boolean}
 */
export function isValidDldUuid(dldUuid) {
  if (
    _.isString(dldUuid) &&
    _.startsWith(dldUuid, UUID_PREFIX_DLD) &&
    dldUuid.length === 39
  ) {
    return uuid.version(dldUuid.substring(UUID_PREFIX_DLD.length)) === 4;
  }
  return false;
}

/**
 * Adds dld_uuid as meta_data attr to basket item
 * @param basketItem
 * @returns basketItemCopy with updated meta_data
 */
export function addDldUuidToCarwashBasketItemMetaData(basketItem) {
  let basketItemCopy = cloneDeep(basketItem);
  if (_.has(basketItemCopy, ["meta_data", META_DATA_ATTR_DLD_UUID])) {
    let dldList = basketItemCopy.meta_data[META_DATA_ATTR_DLD_UUID];
    let dldCount = _.size(dldList);

    // check + replace dld_uuid if invalid
    if (dldCount === MAX_DLD_COUNT && !isValidDldUuid(dldList[0])) {
      basketItemCopy.meta_data[META_DATA_ATTR_DLD_UUID] = [
        UUID_PREFIX_DLD + uuidv4()
      ];
    }

    if (dldCount > MAX_DLD_COUNT) {
      // remove obsolete dld_uuid
      if (!isValidDldUuid(dldList[0])) {
        basketItemCopy.meta_data[META_DATA_ATTR_DLD_UUID] = [
          UUID_PREFIX_DLD + uuidv4()
        ];
      } else {
        basketItemCopy.meta_data[META_DATA_ATTR_DLD_UUID] = [dldList[0]];
      }
    }
  } else {
    basketItemCopy.meta_data[META_DATA_ATTR_DLD_UUID] = [
      UUID_PREFIX_DLD + uuidv4()
    ];
  }
  return basketItemCopy;
}
